module.exports = __webpack_public_path__ + "static/media/winter-gala.0e0bc72a.jpg";